export const TOGGLE_NEW_ORDER_POPUP = 'NewOrderPopUp/TOGGLE_NEW_ORDER_POPUP';
